import React from 'react';

// Web slider with modern styling support
const WebSlider = React.forwardRef(
  (
    {
      minimumValue = 0,
      maximumValue = 1,
      step = 1,
      value = 0,
      onValueChange,
      style,
      className,
      fillPercent,
      accentColor = '#84D288',
      trackColor = '#e5e5e5',
      ...rest
    },
    ref
  ) => {
    const percent = fillPercent ?? ((value - minimumValue) / (maximumValue - minimumValue)) * 100;
    return (
      <input
        type="range"
        className={className}
        min={minimumValue}
        max={maximumValue}
        step={step}
        value={value}
        onChange={(e) => onValueChange?.(Number(e.target.value))}
        ref={ref}
        style={{
          width: '100%',
          '--slider-fill': `${percent}%`,
          '--slider-accent': accentColor,
          '--slider-track': trackColor,
          ...(typeof style === 'object' ? style : {}),
        }}
        {...rest}
      />
    );
  }
);

export default WebSlider;

